import { MapPin } from "lucide-react";

export default function Footer({ config }) {
  return (
    <footer data-testid="footer" className="bg-gris-charcoal text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-10">
          <div className="flex items-center gap-5">
            <img
              src="/logo-hero.webp"
              alt="Segundo Informe de Gobierno — Lic. Mónica Zacil Villarreal Anaya"
              className="h-[200px] w-auto object-contain [filter:drop-shadow(0_6px_18px_rgba(0,0,0,0.45))]"
            />
          </div>
          <nav className="flex flex-wrap gap-x-7 gap-y-3 text-sm text-arena" aria-label="Secciones del pie de página">
            <a href="#reconocimientos" className="hover:text-white transition-colors duration-200">Reconocimientos</a>
            <a href="#ejes" className="hover:text-white transition-colors duration-200">Ejes y Logros</a>
            <a href="#mapa" className="hover:text-white transition-colors duration-200">Impacto en Colonias</a>
            <a href="#fact-checking" className="hover:text-white transition-colors duration-200">Evidencias</a>
            <a href="#propuestas" className="hover:text-white transition-colors duration-200">Participa</a>
          </nav>
        </div>
        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-arena/70">
          <p className="inline-flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5" aria-hidden="true" />
            Tampico, Tamaulipas, México
          </p>
          <p>Portal informativo con fines de transparencia y rendición de cuentas · 2026</p>
        </div>
      </div>
    </footer>
  );
}
